// extracted by mini-css-extract-plugin
export default {"table":"DrawDatesTable_table__kVd9Q"};